import React, {useEffect, useState} from 'react';
import './infoBlockSection.scss';
import ContentBlockItemBg1 from "./components/ContentBlockItem1.svg";
import ContentBlockItemBg2 from "./components/ContentBlockItem2.svg";
import ContentBlockItemBg3 from "./components/ContentBlockItem3.svg";
import ContentBlockItemBgAdaptive1 from "./components/ContentBlockItemAdaptive1.svg";
import ContentBlockItemBgAdaptive2 from "./components/ContentBlockItemAdaptive2.svg";
import ContentBlockItemBgAdaptive3 from "./components/ContentBlockItemAdaptive3.svg";

const InfoBlockSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	return (
		<div className="infoBlock">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="infoBlock__content">
				<div className="infoBlock__content_item">
					<img src={width > 767 ? ContentBlockItemBg1 : ContentBlockItemBgAdaptive1}  alt={'Idea'}/>
					<div className="infoBlock__content_item_data">
						<div className="infoBlock__content_item_data_title">
							<h1>1</h1>
							<div className="infoBlock__content_item_data_title_text">
								<p>Great people</p>
								<p>Great products</p>
							</div>
						</div>
						<div className="infoBlock__content_item_data_text">
						<span>
							Behind every successful product stands a team of passionate individuals
							driven to create something meaningful and valuable for society.
						</span>
							<span>
							We are no exception. Every success we achieve is thanks to our talented
							team and the people who bring our bold ideas to life with precision and care.
						</span>
						</div>
					</div>
				</div>

				<div className="infoBlock__content_item">
					<img src={width > 767 ? ContentBlockItemBg2 : ContentBlockItemBgAdaptive2}  alt={'Idea'}/>
					<div className="infoBlock__content_item_data">
						<div className="infoBlock__content_item_data_title">
							<h1>2</h1>
							<div className="infoBlock__content_item_data_title_text">
								<p>Real products</p>
								<p>Real challenges</p>
							</div>
						</div>
						<div className="infoBlock__content_item_data_text">
						<span>
							Our team has fostered the growth of outstanding specialists, evolving
							together and perfecting skills through real-world challenges.
						</span>
							<span>
							We thrive on a steady workflow filled with exciting tasks, constantly exploring
							new approaches and incorporating innovative solutions into our products.
						</span>
						</div>
					</div>
				</div>

				<div className="infoBlock__content_item">
					<img src={width > 767 ? ContentBlockItemBg3 : ContentBlockItemBgAdaptive3}  alt={'Idea'}/>
					<div className="infoBlock__content_item_data">
						<div className="infoBlock__content_item_data_title">
							<h1>3</h1>
							<div className="infoBlock__content_item_data_title_text">
								<p>Good vibe</p>
								<p>Good ideas</p>
							</div>
						</div>
						<div className="infoBlock__content_item_data_text">
						<span>
							A strong idea fuels great work. We want every team member to feel they belong,
							doing what excites them and where they excel.
						</span>
							<span>
							If you’re a skilled communicator who values collaboration and
							embraces new ideas, we’d love to have you join our team.
						</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InfoBlockSection;